module.exports = __webpack_public_path__ + "img/odnoklassniki.3361676d.svg";